module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-clear-cbc6d393f31d85e2861f598e4868484a.svg";